import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { ContentLayer } from '../../../primitives/ContentLayer/index.js';
export const Content = /*#__PURE__*/_styled(ContentLayer, process.env.NODE_ENV === "production" ? {
  target: "e12ce06s0"
} : {
  target: "e12ce06s0",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "s3oxtx",
  styles: "z-index:5"
} : {
  name: "s3oxtx",
  styles: "z-index:5/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTRDIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDb250ZW50TGF5ZXIgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL0NvbnRlbnRMYXllci9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgQ29udGVudCA9IHN0eWxlZChDb250ZW50TGF5ZXIpIGBcbiAgei1pbmRleDogNTtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db250ZW50LmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});